<template>
    <v-textarea v-model="modelValue" v-bind="{ ...attrs_input_common, ...$attrs }" filled @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-textarea>
</template>

<script>
import { attrs_input_common } from "@/assets/variables";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {},
    data() {
        return {
            attrs_input_common,

            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
